// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-content-design {
    flex-grow: 1;
}

.design-search-filters {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 20px;
    border: 1px solid #ddd;
    background-color: #f8f9fa;
    border-radius: 5px;
    margin-bottom: 20px;
}

.design-search-filters label {
    font-weight: bold;
}

.design-search-filters .filter-select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 300px;
}

.search-button-design {
    display: block;
    width: 343px;
    padding: 15px;
    background-color: #222;
    color: white;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 30px auto;
}

.design-list-container {
    margin-top: 30px;
}

.design-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.design-list-header span {
    font-size: 16px;
    font-weight: bold;
}

.btn-add-banner {
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
}

.design-table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #333;
}

.design-table th,
.design-table td {
    text-align: center;
    padding: 15px 10px;
    border-bottom: 1px solid #ddd;
    vertical-align: middle;
}

.design-table th {
    font-weight: bold;
    background-color: #f8f9fa;
}

.design-table td select,
.design-table td input[type="text"] {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 90%;
    box-sizing: border-box;
}

.design-table td .size-input-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.design-table td .size-input {
    width: 60px;
}

.design-table td .btn-edit {
    background-color: #222;
    border: 1px solid #222;
    color: white;
    padding: 8px 15px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;
}

.design-table td .btn-edit:hover {
    background-color: #333;
    border-color: #333;
}

.design-list-actions {
    margin-top: 20px;
    display: flex;
    gap: 10px;
}

.design-list-actions button {
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;
    font-weight: bold;
}

.design-list-actions .btn-delete-selected {
    background-color: #222;
    color: white;
    border: none;
}

.design-table input[type="url"] {
    font-family: monospace;
    font-size: 13px;
    color: #0066cc;
}

.design-table input[type="url"]:focus {
    outline: 2px solid #e84118;
    border-color: #e84118;
}

.design-table input[type="url"]::placeholder {
    color: #999;
    font-family: inherit;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .design-search-filters {
        flex-direction: column;
        align-items: stretch;
    }

    .design-search-filters .filter-select {
        width: 100%;
    }

    .search-button-design {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .design-list-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .design-table thead {
        display: none;
    }

    .design-table, .design-table tbody, .design-table tr, .design-table td {
        display: block;
        width: 100%;
    }

    .design-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
    }

    .design-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
        border-bottom: 1px solid #eee;
    }
    
    .design-table td:last-child {
        border-bottom: none;
    }

    .design-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
    
    .design-table td select,
    .design-table td input[type="text"],
    .design-table td input[type="url"] {
        width: 100%;
        min-width: 150px;
    }

    .design-table input[type="url"] {
        font-size: 12px;
        padding: 8px;
    }

    .design-list-actions {
        flex-direction: column;
    }

    .design-list-actions button {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/DesignManagementPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;;;QAGI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".admin-content-design {\n    flex-grow: 1;\n}\n\n.design-search-filters {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    padding: 20px;\n    border: 1px solid #ddd;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.design-search-filters label {\n    font-weight: bold;\n}\n\n.design-search-filters .filter-select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 300px;\n}\n\n.search-button-design {\n    display: block;\n    width: 343px;\n    padding: 15px;\n    background-color: #222;\n    color: white;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin: 30px auto;\n}\n\n.design-list-container {\n    margin-top: 30px;\n}\n\n.design-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.design-list-header span {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.btn-add-banner {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.design-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-top: 2px solid #333;\n}\n\n.design-table th,\n.design-table td {\n    text-align: center;\n    padding: 15px 10px;\n    border-bottom: 1px solid #ddd;\n    vertical-align: middle;\n}\n\n.design-table th {\n    font-weight: bold;\n    background-color: #f8f9fa;\n}\n\n.design-table td select,\n.design-table td input[type=\"text\"] {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 90%;\n    box-sizing: border-box;\n}\n\n.design-table td .size-input-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n\n.design-table td .size-input {\n    width: 60px;\n}\n\n.design-table td .btn-edit {\n    background-color: #222;\n    border: 1px solid #222;\n    color: white;\n    padding: 8px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: all 0.3s ease;\n}\n\n.design-table td .btn-edit:hover {\n    background-color: #333;\n    border-color: #333;\n}\n\n.design-list-actions {\n    margin-top: 20px;\n    display: flex;\n    gap: 10px;\n}\n\n.design-list-actions button {\n    padding: 10px 20px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    background-color: white;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.design-list-actions .btn-delete-selected {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.design-table input[type=\"url\"] {\n    font-family: monospace;\n    font-size: 13px;\n    color: #0066cc;\n}\n\n.design-table input[type=\"url\"]:focus {\n    outline: 2px solid #e84118;\n    border-color: #e84118;\n}\n\n.design-table input[type=\"url\"]::placeholder {\n    color: #999;\n    font-family: inherit;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .design-search-filters {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .design-search-filters .filter-select {\n        width: 100%;\n    }\n\n    .search-button-design {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .design-list-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .design-table thead {\n        display: none;\n    }\n\n    .design-table, .design-table tbody, .design-table tr, .design-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .design-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n    }\n\n    .design-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n        border-bottom: 1px solid #eee;\n    }\n    \n    .design-table td:last-child {\n        border-bottom: none;\n    }\n\n    .design-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n    \n    .design-table td select,\n    .design-table td input[type=\"text\"],\n    .design-table td input[type=\"url\"] {\n        width: 100%;\n        min-width: 150px;\n    }\n\n    .design-table input[type=\"url\"] {\n        font-size: 12px;\n        padding: 8px;\n    }\n\n    .design-list-actions {\n        flex-direction: column;\n    }\n\n    .design-list-actions button {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
